import { useEffect } from 'react';

var DisableBackgroundScroll = function DisableBackgroundScroll(_ref) {
  var isActive = _ref.isActive;
  useEffect(function () {
    // turn scrolling on or off
    if (isActive) {
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    } else {
      document.getElementsByTagName('html')[0].style.overflow = 'initial';
    }
    // allways turn scrolling back on when component unmounts
    return function () {
      document.getElementsByTagName('html')[0].style.overflow = 'initial';
    };
  }, [isActive]);
  return '';
};

export { DisableBackgroundScroll as default };
